import type { DataTableColumn as GridColDef } from '@/components/custom/erp';
import { formatDate, formatMoney } from '@/lib/formatUtils';

export const invoiceReportColumns = (handleDocumentFormClick: (obj: BanHangRecord) => void): GridColDef[] => [
  {
    field: 'ma_unit',
    headerName: 'Đơn vị',
    width: 140
  },
  {
    field: 'ngay_ct',
    headerName: 'Ngày c/từ',
    width: 110,
    renderCell: params => formatDate(params.row.ngay_ct)
  },
  {
    field: 'so_ct',
    headerName: 'Số c/từ',
    width: 200,
    renderCell: params => (
      <button onClick={() => handleDocumentFormClick(params.row)} className='hover:text-blue-500 hover:underline'>
        {params.row.so_ct}
      </button>
    )
  },
  {
    field: 'so_ct0',
    headerName: 'Số hóa đơn',
    width: 110,
    renderCell: params => params.row.so_ct0
  },
  {
    field: 'ma_kh',
    headerName: 'Mã khách hàng',
    width: 140
  },
  {
    field: 'ten_kh',
    headerName: 'Tên khách hàng',
    width: 200,
    cellClassName: params => (!params.row.stt ? 'font-bold' : '')
  },
  {
    field: 'dien_giai',
    headerName: 'Diễn giải',
    width: 250
  },
  {
    field: 'tien2',
    headerName: 'Doanh thu',
    width: 120,
    type: 'number',
    valueGetter: value => formatMoney(value),
    cellClassName: params => (!params.row.stt ? 'font-bold' : '')
  },
  {
    field: 'thue',
    headerName: 'Thuế',
    width: 120,
    type: 'number',
    valueGetter: value => formatMoney(value),
    cellClassName: params => (!params.row.stt ? 'font-bold' : '')
  },
  {
    field: 'ck',
    headerName: 'Chiết khấu',
    width: 120,
    type: 'number',
    valueGetter: value => formatMoney(value),
    cellClassName: params => (!params.row.stt ? 'font-bold' : '')
  },
  {
    field: 'pt',
    headerName: 'Phải thu',
    width: 120,
    type: 'number',
    valueGetter: value => formatMoney(value),
    cellClassName: params => (!params.row.stt ? 'font-bold' : '')
  },
  {
    field: 'ma_nvbh',
    headerName: 'Mã nv bán hàng',
    width: 120
  },
  {
    field: 'ten_nvbh',
    headerName: 'Tên nv bán hàng',
    width: 250
  },
  {
    field: 'ma_vv',
    headerName: 'Vụ việc',
    width: 120
  },
  {
    field: 'ma_hd',
    headerName: 'Hợp đồng',
    width: 120
  },
  {
    field: 'ma_ct',
    headerName: 'Mã c/từ',
    width: 120
  }
];
